// Order History Utility Functions

export const formatDateForAPI = (date) =>
  date ? date.toISOString().slice(0, 10) : "";

export const normalizeOrderType = (type) => {
  if (!type || typeof type !== "string") return "";
  return type.toLowerCase().replace(/[_-]/g, " ").trim();
};

export const getLocalDateString = (dateStr) =>
  new Date(dateStr).toLocaleDateString("en-CA");

export const formatOrderType = (type) => {
  if (!type) return "-";

  const normalized = type.toLowerCase().replace(/[_-]/g, " ");

  if (normalized.includes("qr")) {
    return "QR Order";
  }

  return normalized.replace(/\b\w/g, (c) => c.toUpperCase());
};

export const formatOrderedTime = (dateStr) => {
  if (!dateStr) return "-";

  const date = new Date(dateStr);

  return date.toLocaleString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};

export const countByStatus = (orders, status) =>
  orders.filter(
    (o) => o.status?.trim().toLowerCase() === status.trim().toLowerCase(),
  ).length;

export const getTotalSales = (orders) =>
  orders.reduce((sum, order) => sum + Number(order.amount || 0), 0);
